import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import PremiumThankYou from '../components/PremiumThankYou';

const SubmittedProjectPage = () => {
  usePageMeta({
    title: 'Request Received | BM-Assist.co',
    description: 'Your project request has been received. We will review it and follow up with scope and pricing details.',
    ogTitle: 'Request Received | BM-Assist.co',
    ogDescription: 'Thank you for submitting your project request to BM-Assist.'
  });

  const bulletPoints = [
    "Your request is in our queue and being reviewed",
    "We'll send you a quote or follow-up questions within 24 hours",
    "Once approved, we'll kick off your project right away"
  ];

  return (
    <PremiumThankYou
      title="Request Received!"
      subtitle="We're excited to help grow your business."
      bulletPoints={bulletPoints}
      primaryButtonText="Back to Home"
      primaryButtonLink="/"
      secondaryButtonText="View Our Bundles"
      secondaryButtonLink="/bundles"
    />
  );
};

export default SubmittedProjectPage;
